import { Controller } from '@hotwired/stimulus'

// The bottom CTA repeats the register call-to-action for a visitor who has scrolled past the
// top one. Reveal it only once the top CTA has actually left the viewport, so a page that
// fits on one screen never shows the same buttons twice. Same approach as the product page's
// sticky buy bar.
export default class extends Controller {
  static values = { sentinelId: String }

  connect() {
    const sentinel = document.getElementById(this.sentinelIdValue)
    // The element renders empty in states that must not repeat — it exists only as a
    // stable target for the register/cancel ajax responses, so there is nothing to reveal.
    if (!sentinel || this.element.children.length === 0) return

    this.observer = new IntersectionObserver(
      ([entry]) =>
        this.element.classList.toggle('hidden', entry.isIntersecting),
      { threshold: 0 }
    )
    this.observer.observe(sentinel)
  }

  disconnect() {
    this.observer?.disconnect()
  }
}
